// removed by extract-text-webpack-plugin
module.exports = {"pageLink":"_2heX4mB3YktaG4a0N_GVK_","disabled":"jmry4HZE64joQkH4LY3Ln","active":"CnDpMJJtCcGP4pF8RgG3r"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AdvisorMode/Clients.css
// module id = 833
// module chunks = 0